import { render, staticRenderFns } from "./PersonPayrollDirectAssignmentNew.vue?vue&type=template&id=669caab9"
import script from "./PersonPayrollDirectAssignmentNew.vue?vue&type=script&lang=js"
export * from "./PersonPayrollDirectAssignmentNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports